import $ from 'jquery';

export class Video {
  constructor($trigger) {
    this.$trigger = $trigger;
    this.$videoComponent = $trigger.closest('.js-c-video');
    this.$videoHolder = this.$videoComponent.find('.c-video__holder');
    this.bindEvents();
  }
  
  bindEvents() {
    this.$trigger.on('click', event => {
        event.preventDefault();
        this.onTriggerClick(event);
    });
  }
  
  onTriggerClick() {
    this.$videoComponent.addClass('is-active');

    //play video after the css3 transition is complete
    this.$videoHolder.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
      $(this).find('iframe')[0].src += "&autoplay=1";
    });
  }
}